import {Button, Table} from "react-bootstrap";
import React, {useState} from "react";
import {BoxArrowUpRight, ChevronDown, ChevronUp, GeoAlt, GeoAltFill, PlayFill, SortAlphaDown, SortAlphaUp, StopFill} from "react-bootstrap-icons";
import FilterInput from "./FilterInput";
import useFilteredMachinesList from "../hooks/useFilteredMachinesList";
import {NavigationSkills} from "./NavigationSkills";
import useMqttClient from "../hooks/useMqttClient";
import * as Const from "../Const";


function MachineRow({mqttClient, machine, navigationSkill, onMachineClicked, rowClass = ""}) {

    const [isButtonDisabled, setButtonDisabled] = useState(false);

    const canStartMachine = machine.isOnline && navigationSkill && !navigationSkill.activateAutonomy;
    const canStopMachine = machine.isOnline && navigationSkill && navigationSkill.activateAutonomy;

    const handleStartStopClick = (event, payload) => {
        setButtonDisabled(true);
        setTimeout(() => {setButtonDisabled(false)}, 5000);
        let topic = machine.name + "/" + Const.MQTT_PUBLISH_CMD_ACTIVATE_AUTONOMY;
        console.log("publishing MQTT", topic, payload);
        mqttClient?.publish(topic, payload, {qos: 0, retain: false});
    };

    return (
        <tr className={rowClass}>
            <td className={"align-text-bottom"}>
                {machine.isPositionKnown ? (machine.isOnline ? <GeoAltFill /> : <GeoAlt />) : null}
            </td>
            <td className={"overflow-hidden"} onClick={() => onMachineClicked(machine.name)}>
                <div className={"text-truncate"}>{machine.name}</div>
                {machine.isOnline ? <a role={"button"} target={"new"} href={`http://${machine.name}.vpn.kl.rm`} className={"link-secondary"}>Open Interface <BoxArrowUpRight /></a> : null}
                {navigationSkill ? <NavigationSkills navigationSkill={navigationSkill} /> : null }
            </td>
            <td className={"align-middle"}>
                {canStartMachine && mqttClient
                    ? <div className={"btn btn-sm btn-outline-secondary d-flex align-items-center" + (isButtonDisabled ? " disabled" : "")} onClick={(event) => {
                        handleStartStopClick(event, "1");
                    }}>Start <PlayFill className={"h6 my-0"}/></div>
                    : null
                }
                {canStopMachine && mqttClient
                    ? <div className={"btn btn-sm btn-outline-secondary d-flex align-items-center" + (isButtonDisabled ? " disabled" : "")} onClick={(event) => {
                        handleStartStopClick(event, "0");
                    }}>Stop <StopFill className={"h6 my-0"}/></div>
                    : null
                }
            </td>
        </tr>
    );
}


function OverviewMachineList( {mqttClient, machines, machineStates, livePositions, navigationSkills, selectedMachineName, machineFilter,
                                  highlightedMachines, selectedFieldName,
                                  onMachineClicked, onMachineFilterChanged}
) {

    const [isTableOpen, setTableOpen] = useState(true);

    const [showOnlyOnline, setShowOnlyOnline] = useState(false);
    const [sortDirection, setSortDirection] = useState(1);

    // const filteredMachines = useMachinesFilteredBySelectedField(machines, selectedField, machineFieldMapping);
    const displayedMachines = useFilteredMachinesList(machines, machineStates, livePositions, machineFilter, sortDirection, showOnlyOnline, selectedFieldName, highlightedMachines, selectedMachineName);

    // const selectedMachines = useMemo(() => {
    //     return displayedMachines.filter(m => m.name === selectedMachineName);
    // }, [displayedMachines, selectedMachineName])

    // console.log("list update");

    // const [client, isConnected] = useMqttClient(null, null);


    return (
        <div className={"card shadow-lg"}>
            <div className={"card-header"}>
                <Button className={"btn-light shadow-none"} onClick={() => setTableOpen(!isTableOpen)}>
                    { isTableOpen ? <><ChevronDown /> Machines</> : <><ChevronUp /> Machines</> }
                </Button>
                { isTableOpen
                    ?
                    <div className={"w-100"}>
                        <Button className={"btn-light shadow-none"} onClick={() => setShowOnlyOnline(!showOnlyOnline)}>
                            {showOnlyOnline ? <GeoAltFill /> : <GeoAlt />} Online
                        </Button>
                        <Button className={"btn-light shadow-none"} onClick={() => setSortDirection(-sortDirection)}>
                            <div> {sortDirection > 0 ? <SortAlphaDown /> : <SortAlphaUp />} Sort</div>
                        </Button>
                        <FilterInput filter={machineFilter} onFilterChanged={(filter) => onMachineFilterChanged(filter)} />
                    </div>
                    : null
                }
            </div>
            { isTableOpen && displayedMachines
                ? <div className={"card-body"} style={{maxHeight: "100%", overflowY: "auto", overflowX: "hidden"}}>
                    <Table className={"table-sm m-0"}>
                        <tbody>
                        { displayedMachines.map(m => {
                            const skill = navigationSkills[m.name];
                            const hasError = skill?.hasError;
                            const hasWarning = skill?.isOperatorRequired || skill?.isDependency;
                            const rowClass =
                                m.name === selectedMachineName ? "table-primary" :
                                    hasError ? "table-danger" :
                                        hasWarning ? "table-warning" :
                                            highlightedMachines?.includes(m.name) ? "table-success" : "";
                            return <MachineRow key={m.name} mqttClient={mqttClient} machine={m} navigationSkill={skill} rowClass={rowClass} onMachineClicked={onMachineClicked}/>;
                        })
                        }
                        </tbody>
                    </Table>
                </div>
                : null
            }
        </div>
    );
}


export default OverviewMachineList;
